import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiCalendarRemoveOutline } from "@mdi/js";
import {
  setCurrentStep,
  fetchBookingConfig,
  resetBookingOutcome,
} from "../slice";
import BookingHeader from "./BookingHeader";
import { REPORT_BUG_HELP_LINK } from "app/constants/global-constants";
import { getFirstNameInitial } from "../utils";

const BookingErrorPage = ({ isInitialLoadError = false }) => {
  const dispatch = useDispatch();
  const { uniqueId } = useParams();
  const { companyInfo, inspectorInfo } = useSelector(
    (state) => state.publicClientBooking
  );

  const handleTryAgain = () => {
    if (isInitialLoadError) {
      dispatch(fetchBookingConfig(uniqueId));
    } else {
      dispatch(resetBookingOutcome());
      dispatch(setCurrentStep(0));
    }
  };

  return (
    <div className="public-client-booking-container">
      <BookingHeader
        companyName={companyInfo?.name}
        companyLogo={companyInfo?.logo}
      />
      <main className="public-client-booking-outcome-main">
        <div className="public-client-booking-failure-icon-wrapper">
          <Icon path={mdiCalendarRemoveOutline} color="#fff" />
        </div>

        <h1 className="public-client-booking-outcome-title">
          Something went wrong
        </h1>
        <p className="public-client-booking-outcome-subtitle">
          Sorry, we couldn&apos;t process your booking.
          <br />
          Please try again or contact your inspector directly.
        </p>

        {/* Inspector card */}
        {inspectorInfo && (
          <>
            <div className="public-client-booking-success-inspector-label">
              Your Inspector
            </div>
            <div className="public-client-booking-success-inspector-card">
              <div className="public-client-booking-success-inspector-row">
                {inspectorInfo.profile_image_url ? (
                  <img
                    src={inspectorInfo.profile_image_url}
                    alt={inspectorInfo.name}
                    className="public-client-booking-success-inspector-avatar"
                  />
                ) : (
                  <div className="public-client-booking-success-inspector-initial">
                    {getFirstNameInitial(inspectorInfo.name)}
                  </div>
                )}
                <div>
                  <div className="public-client-booking-success-inspector-name">
                    {inspectorInfo.name}
                  </div>
                  <div className="public-client-booking-confirm-field-meta-row">
                    {inspectorInfo.phone && <span>{inspectorInfo.phone}</span>}
                    {inspectorInfo.email && <span>{inspectorInfo.email}</span>}
                  </div>
                  {inspectorInfo.license_number && (
                    <div className="public-client-booking-success-inspector-meta">
                      License Number: {inspectorInfo.license_number}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <button
          type="button"
          className="btn btn-primary public-client-booking-outcome-btn"
          onClick={handleTryAgain}
        >
          Try Again
        </button>

        <p className="public-client-booking-error-support-text">
          If the error continues, please contact{" "}
          <a
            href={REPORT_BUG_HELP_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            Morph Support
          </a>{" "}
          for assistance.
        </p>
      </main>
    </div>
  );
};

export default BookingErrorPage;
